/* utils */
import { randomString } from 'util/string'

let timeoutId // global periodical task runner interval
let tasks = {} //tasks
let taskCount = 0
let stopped = false

const TICK = 1000 // base interval

export const addTask = (callback, shouldRun) => {
  const task = {
    uid: randomString(),
    created: Date.now(),
    lastRun: Date.now(),
    iteration: 0,
    callback,
    shouldRun
  }
  tasks[task.uid] = task
  taskCount++
  if (!stopped && !timeoutId) start()
}


export const removeTask = (task) => {
  if (tasks[task.uid]) {
    tasks[task.uid] = null
    delete tasks[task.uid]
    taskCount--
  }
  if (!stopped && taskCount <= 0) stop()
  if (taskCount < 0) throw new Error("Task Count Error", tasks)
}

const run = () => {
  _.each(tasks, (value, key) => {
    if (
      !value.shouldRun
      || value.shouldRun === true
      || value.shouldRun(value)
    ) {
      value.callback(value)
      value.lastRun = Date.now()
      value.iteration++
    }
  })
  if (stopped) return
  timeoutId = setTimeout(run, TICK)
}

export const start = () => {
  stopped = false
  if (timeoutId) clearTimeout(timeoutId)
  timeoutId = setTimeout(run, TICK)
}

export const stop = () => {
  stopped = true
  if (timeoutId) clearTimeout(timeoutId)
  timeoutId = null
}



// WEBPACK FOOTER //
// ./src/app/util/taskrunner.js